import { AnimatePresence, motion } from "framer-motion";
import { AlertTriangle } from "lucide-react";

export default function ConfirmDialog({
  open,
  title = "Are you sure?",
  description = "This action cannot be undone.",
  confirmLabel = "Delete",
  cancelLabel = "Cancel",
  destructive = true,
  loading = false,
  onConfirm,
  onCancel,
}) {
  return (
    <AnimatePresence>
      {open && (
        <motion.div
          className="fixed inset-0 z-[120] flex items-center justify-center bg-black/70 px-4 backdrop-blur-md"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onCancel}
          data-testid="confirm-dialog"
        >
          <motion.div
            onClick={(e) => e.stopPropagation()}
            initial={{ opacity: 0, y: 20, scale: 0.96 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 20, scale: 0.96 }}
            transition={{ duration: 0.25, ease: [0.16, 1, 0.3, 1] }}
            className="w-full max-w-md overflow-hidden rounded-3xl border border-white/10 bg-[#0a0a0c] p-7 shadow-2xl"
          >
            <div
              className={`mb-5 flex h-12 w-12 items-center justify-center rounded-full ${
                destructive ? "bg-red-500/10 text-red-400" : "bg-[#0055ff]/10 text-[#0055ff]"
              }`}
            >
              <AlertTriangle className="h-5 w-5" />
            </div>
            <h3 className="font-display text-2xl font-medium tracking-tight text-white">{title}</h3>
            <p className="mt-2 font-body text-sm text-white/55">{description}</p>
            <div className="mt-6 flex items-center justify-end gap-3">
              <button
                type="button"
                onClick={onCancel}
                disabled={loading}
                className="rounded-full border border-white/12 px-5 py-2.5 font-body text-sm text-white/75 transition hover:border-white/30 hover:text-white disabled:opacity-50"
                data-testid="confirm-cancel"
              >
                {cancelLabel}
              </button>
              <button
                type="button"
                onClick={onConfirm}
                disabled={loading}
                className={`rounded-full px-5 py-2.5 font-body text-sm font-medium text-white transition disabled:opacity-60 ${
                  destructive
                    ? "bg-red-500 hover:bg-red-400"
                    : "bg-[#0055ff] hover:bg-[#1a66ff]"
                }`}
                data-testid="confirm-action"
              >
                {loading ? "Working…" : confirmLabel}
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
